import {dedupingMixin} from "@polymer/polymer/lib/utils/mixin";

/**
 * @polymer
 * @mixinFunction
 **/
export const DropdownBehavior = dedupingMixin((superClass) => class extends superClass {
  static get properties() {
    return {
      dropdownElement: Object
    }
  }

  connectedCallback() {
    super.connectedCallback();

    this.dropdownElement = document.createElement('keli-dropdown-container');
    this.dropdownElement.element = this;
    document.body.appendChild(this.dropdownElement);
    if (this.dropdownBehaviorStyles) {
      this.dropdownElement.applyCustomStyles(this.dropdownBehaviorStyles);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.dropdownElement) {
      this.dropdownElement.remove();
      this.dropdownElement = null;
    }
  }
});